import { render, staticRenderFns } from "./VFormFieldWrapper.vue?vue&type=template&id=5db3d528"
import script from "./VFormFieldWrapper.vue?vue&type=script&lang=js"
export * from "./VFormFieldWrapper.vue?vue&type=script&lang=js"
import style0 from "./VFormFieldWrapper.vue?vue&type=style&index=0&id=5db3d528&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports